import React, {Component} from 'react';
import NavBar from "./NavBar";
import Footer from "./Footer";

class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            subject: '',
            message: ''
        };
    }

    submit(e) {
        e.preventDefault();
        let name = this.state.name;
        let email = this.state.email;
        let subject = this.state.subject;
        let message = this.state.message;

        let url = `https://script.google.com/macros/s/AKfycbzrT82-yxg_6juSjfefxMZT734qBxmLI7v1iRKIX2pSj38oDNA/exec?email=${email}&name=${name}&subject=${subject}&message=${message}`;
        let options = {
            mode: 'no-cors'
        };
        fetch(url, options).then((res) => {
            this.setState({
                name: "",
                email: "",
                subject: "",
                message: ""
            });
            alert("Request submitted, we'll get back to you as soon as we can!");
        }).catch((err) => {
            this.setState({
                name: "",
                email: "",
                subject: "",
                message: ""
            });
        })
    }

    componentDidMount() {
        document.title = "RigChecks - Contact";
    }

    handleChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    render() {
        return (
            <div>
                <NavBar/>
                <div className="pt-5 pb-3"/>
                <div className="pt-5 pb-3"/>

                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-sm-8 my-5">
                            <div className="card">
                                <h5 className="card-header lead"><strong>Contact Us</strong></h5>
                                <div className="card-body">
                                    <form>
                                        <div className="form-group">
                                            <div className="form-row">
                                                <div className="col-md-6">
                                                    <label htmlFor="nameInput">Name:</label>
                                                    <input value={this.state.name}
                                                           onChange={(e) => this.handleChange(e)}
                                                           className="form-control"
                                                           id="nameInput" type="text" name="name"
                                                           aria-describedby="nameHelp" placeholder="Chief Smith"/>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="emailInput">Email address:</label>
                                                    <input value={this.state.email}
                                                           onChange={(e) => this.handleChange(e)}
                                                           className="form-control"
                                                           id="emailInput" type="email" name="email"
                                                           aria-describedby="emailHelp" placeholder="chief@ems.com"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-row">
                                                <div className="col-md-12">
                                                    <label htmlFor="subjectInput">Subject:</label>
                                                    <input value={this.state.subject}
                                                           onChange={(e) => this.handleChange(e)}
                                                           className="form-control"
                                                           id="subjectInput" type="text" name="subject"
                                                           placeholder="Demo Request"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-row">
                                                <div className="col-md-12">
                                                    <label htmlFor="messageTextarea">Message:</label>
                                                    <textarea value={this.state.message}
                                                              onChange={(e) => this.handleChange(e)}
                                                              name="message" placeholder="We want a demo for our crew!"
                                                              className="form-control" id="messageTextarea" rows="3">
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <button className="btn btn-primary btn-block"
                                                type="submit" onClick={(e) => this.submit(e)}>Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Footer/>
            </div>
        )
    }

}

export default Contact;




// WEBPACK FOOTER //
// ./src/component/Contact.js